// Calendar dates that come from other modules (not from calendar_events): risk assessment reviews, crew contract ends
// and passage plans. Shared by the Calendar page and the AI (list_calendar_events) so both show the same dates.
// Pure: plain snake_case database rows in, plain events out (no React, no browser).

// columns each source needs (the page and the AI select exactly these)
export const CAL_SELECT = {
  risk_assessments: 'id,ra_number,activity,location,next_review_due,status',
  crew: 'id,name,first_name,last_name,position,contract_end_date,archived',
  passage_plans: 'id,title,departure_port,arrival_port,departure_date,arrival_date,status',
}

// 'YYYY-MM-DD', 'YYYY-MM-DDThh..' or 'DD/MM/YYYY' -> 'YYYY-MM-DD'; anything else -> null
export function calDate(v) {
  const s = String(v == null ? '' : v).trim()
  let m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) return valid(m[1], m[2], m[3])
  m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
  if (m) return valid(m[3], m[2].padStart(2, '0'), m[1].padStart(2, '0'))
  return null
}
function valid(y, mo, d) {
  const t = new Date(Date.UTC(+y, +mo - 1, +d))
  return t.getUTCFullYear() === +y && t.getUTCMonth() === +mo - 1 && t.getUTCDate() === +d ? `${y}-${mo}-${d}` : null
}

export const crewName = c => String(c.name || [c.first_name, c.last_name].filter(Boolean).join(' ')).trim()

// events between from and to (inclusive, YYYY-MM-DD; either may be omitted). A passage counts when any day of it is in range.
export function derivedEvents({ riskAssessments = [], crew = [], passagePlans = [] } = {}, { from, to } = {}) {
  const inRange = (s, e = s) => (!from || e >= from) && (!to || s <= to)
  const out = []
  for (const r of riskAssessments || []) {
    const d = calDate(r.next_review_due)
    if (!d || !inRange(d)) continue
    out.push({ id: 'ra_' + r.id, type: 'ra_review', title: 'RA review: ' + ([r.ra_number, r.activity].filter(Boolean).join(' ') || 'risk assessment'), start: d, ref: { table: 'risk_assessments', id: r.id } })
  }
  for (const c of crew || []) {
    if (c.archived) continue
    const d = calDate(c.contract_end_date)
    if (!d || !inRange(d)) continue
    const nm = crewName(c) || 'Crew member'
    out.push({ id: 'ce_' + c.id, type: 'contract_end', title: 'Contract ends: ' + nm + (c.position ? ' (' + c.position + ')' : ''), start: d, ref: { table: 'crew', id: c.id, name: nm } })
  }
  for (const p of passagePlans || []) {
    const s = calDate(p.departure_date), a = calDate(p.arrival_date)
    const start = s || a
    if (!start) continue
    const end = a && a > start ? a : undefined
    if (!inRange(start, end || start)) continue
    const route = p.title || [p.departure_port, p.arrival_port].filter(Boolean).join(' → ') || 'Passage'
    out.push({ id: 'pp_' + p.id, type: 'passage', title: 'Passage: ' + route, start, ...(end ? { end } : {}), ref: { table: 'passage_plans', id: p.id } })
  }
  return out.sort((x, y) => x.start.localeCompare(y.start))
}
